<template>
  <div id="q-app" class="pragma-black">
    <update-version />
    <router-view />
    <div class="row full-width text-center absolute-bottom" v-if="!online">
      <div class="col-xs-12 text-white text-body1 custom-font">
        Sin conexión
      </div>
    </div>
  </div>
</template>
<script>
import {inject, ref} from "vue"
import { useQuasar } from "quasar"
import { Network } from "@awesome-cordova-plugins/network"
import axios from "axios"
import util from "./plugins/util"
import env from "../config/env"
import UpdateVersion from './components/UpdateVersion.vue'

export default ({
  name: 'App',
  components: {
    UpdateVersion
  },
  setup () {
    const $q = useQuasar()
    const bus = inject('bus')

    const online = ref(true)
    const update_version_dialog = ref(false)
    
    // Métodos y funciones del componente
    const getVersion = async () => {
      if (util.getPlatform() == 'I') {
        let res = await axios.get('mobile/version/ios')
        if (env.VERSION_IOS !== res.data.version) {
          bus.emit('showUpdateVersion')
        }
      } else {
        let res = await axios.get('mobile/version/android')
        if (env.VERSION_ANDROID !== res.data.version) {
          bus.emit('showUpdateVersion')
        }
      }
    }

    // Creación del componente
    getVersion()
    if (!$q.localStorage.getItem('options')) {
      $q.localStorage.set('options', {
        biometric_auth: false,
        username: '',
        hasBiometric: true,
        first_time: true
      })
    }

    Network.onDisconnect().subscribe(() => {
      online.value = false
    })

    Network.onConnect().subscribe(() => {
      online.value = true
    })

    return {
      online,
      update_version_dialog
    }
  }
})
</script>